import React, {useState} from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Icon from "@mui/material/Icon";
// @mui/icons-material
// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown.js";
import styles from "../../styles/jss/nextjs-material-kit/pages/componentsSections/jobsDynamicSearchStyle.js";

import Button from "../../components/CustomButtons/Button";

const useStyles = makeStyles()(styles);

export default function JobFilters({ jobFilters, jobFilterMetadata, onJobFiltersChange, resetJobFilters }) {
  /**
   * @var {Array<{id: number, name: string}>} career_zones
   * @var {Array<string>} job_types
   * @var {Array<{id: number, name: string}>} locations
   */
  let { career_zones, job_types, locations } = jobFilterMetadata;

  /**
   * @param {?string} czName
   */
  const choseCareerZone = (czName = null) => {
    const updatedFilters = {
      ...jobFilters,
      career_zone_id: career_zones.find((zone) => zone.name === czName)?.id || null,
    };
    onJobFiltersChange(updatedFilters);
  }

  /**
   * @param {?string} jobType
   */
  const choseJobType = (jobType) => {
    const updatedFilters = {
      ...jobFilters,
      job_type: jobType,
    };
    onJobFiltersChange(updatedFilters);
  }

  /**
   * @param {?string} locationName
   */
  const choseLocation = (locationName = null) => {
    const updatedFilters = {
      ...jobFilters,
      location_id: locations.find((location) => location.name === locationName)?.id || null,
    };
    onJobFiltersChange(updatedFilters);
  }

  const { classes, cx } = useStyles();
  const getFilterClasses = (filterValue) => {
    if (!filterValue) {
      return cx(classes.dropDown, classes.btnCustomDropdown);
    }

    return cx(classes.dropDown, classes.dropDownInEffect, classes.btnCustomDropdown);
  }

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          buttonText="Career Zone"
          buttonProps={{
            className: getFilterClasses(jobFilters.career_zone_id),
          }}
          selected={jobFilters.career_zone_id ? [career_zones.find(zone => zone.id === jobFilters.career_zone_id)?.name] : []}
          dropdownList={career_zones?.map((zone) => zone.name)}
          onClick={choseCareerZone}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          buttonText="Job Type"
          buttonProps={{
            className: getFilterClasses(jobFilters.job_type),
          }}
          dropdownList={job_types}
          selected={jobFilters.job_type ? [jobFilters.job_type] : []}
          onClick={choseJobType}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          buttonText="Location"
          buttonProps={{
            className: getFilterClasses(jobFilters.location_id),
          }}
          dropdownList={locations?.map((location) => location.name)}
          selected={jobFilters.location_id ? [locations.find(loc => loc.id === jobFilters.location_id)?.name] : []}
          onClick={choseLocation}
        />
      </ListItem>

      {jobFilters.career_zone_id || jobFilters.job_type || jobFilters.location_id ? (
        <ListItem className={cx(classes.listItem, classes.listItemEnd)}>
          <Button
            className={cx(classes.primaryColor, classes.btn)}
            color="info"
            onClick={resetJobFilters}
          >
            Clear filters
          </Button>
        </ListItem>
      ) : null}
    </List>
  );
}

JobFilters.propTypes = {
    jobFilters: PropTypes.shape({
      career_zone_id: PropTypes.number,
      job_type: PropTypes.string,
      location_id: PropTypes.number,
    }).isRequired,
    jobFilterMetadata: PropTypes.shape(
      {
        career_zones: PropTypes.arrayOf(
          PropTypes.shape(
            {
              id: PropTypes.number,
              name: PropTypes.string,
            },
          ),
        ),
        job_types: PropTypes.arrayOf(PropTypes.string),
        locations: PropTypes.arrayOf(
          PropTypes.shape(
            {
              id: PropTypes.number,
              name: PropTypes.string,
            },
          ),
        ),
      },
    ).isRequired,
    onJobFiltersChange: PropTypes.func.isRequired, // Takes a new object in `initialFilters`'s shape.
    resetJobFilters: PropTypes.func.isRequired,
};
